module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card border-0  h-100"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("\n           " + _vm._s(_vm.page.title) + "\n       ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body d-flex flex-column"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "h-100 d-flex align-items-center align-content-center"
  }, [_c('span', [_vm._v("\n                Lädt...\n            ")])]) : (_vm.page.layout === 'youtube') ? _c('Youtube', {
    attrs: {
      "content": _vm.page.content,
      "video_id": _vm.page.video_id
    }
  }) : _c('CenterComponent', {
    attrs: {
      "background_image": _vm.page.url
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-muted "
  }, [_c('div', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "text-left col"
  }, [_c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": _vm.route('trainings.index')
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Zurück zu Campus\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right col"
  }, [_c('div', {
    staticClass: "btn-group ",
    attrs: {
      "role": "group"
    }
  }, [(_vm.canGoBack) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToPreviousPage
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.trans('system.previous')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.canGoForward) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToNextPage
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.trans('system.next')) + "\n                    ")]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f151b1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Info.vue
// module id = 126
// module chunks = 0